import { getters } from '/@/modules/core/app/helpers/store';
import { RouteConfig } from '/@/modules/core/app/helpers/RouteConfig';

export class OpsRouteConfig extends RouteConfig {
  canAccessRoute(): boolean {
    return (
      !!getters.auth.getUser()?.permission?.canManageEstate &&
      !getters.auth.getUser()?.currentEstate
    );
  }
}
